import moment from 'moment-timezone'
import React, {useEffect} from 'react'
import {useLocation} from 'react-router'
import {DrawerComponent} from '../../assets/ts/components'

const Content: React.FC = ({children}) => {
  const location = useLocation()
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  useEffect(() => {
    moment.tz.setDefault('Etc/UTC')
  }, [])

  return (
    <div
      id='gori_content_container'
      className='mx-10 mx-xxl-10 d-flex flex-column flex-column-fluid'
    >
      {children}
    </div>
  )
}

export {Content}
